import { fontFamily } from '../constants.js';

const fontWeightToValue = {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800
};
const fontWeight = (weight)=>({
        "--fontweight": fontWeightToValue[weight]
    });
const fontVariation = ({ disambiguate = false, isMonospace = false, slashedZero = false, tabularFigures = false, weight = "normal" })=>({
        "--mono": isMonospace ? "1" : undefined,
        "--fontweight": weight ? fontWeightToValue[weight] : undefined,
        "--tabularfigures": tabularFigures ? "on" : undefined,
        "--slashedzero": slashedZero ? "on" : undefined,
        "--disambiguate": disambiguate ? "on" : undefined,
        ...isMonospace ? {
            fontFamily: fontFamily.mono
        } : {}
    });

export { fontVariation, fontWeight, fontWeightToValue };
